'use client';

import { c as _c } from "react/compiler-runtime";
import { FeatherSearch, FeatherX } from '@subframe/core';
import { Button, Select, Switch, TextField } from '@/shared/components/ui';
import type { ApuracaoListFilters as ApuracaoListFiltersType, ApuracaoStatus } from '../types';
interface ApuracaoListFiltersProps {
  filters: ApuracaoListFiltersType;
  onChange: (patch: Partial<ApuracaoListFiltersType>) => void;
  onClear: () => void;
}
const STATUS_OPTIONS: {
  value: ApuracaoStatus | 'TODOS';
  label: string;
}[] = [{
  value: 'TODOS',
  label: 'Todos os status'
}, {
  value: 'ABERTO',
  label: 'Aberto'
}, {
  value: 'FECHADO',
  label: 'Fechado'
}, {
  value: 'REABERTO',
  label: 'Reaberto'
}];
const isFiltering = (filters: ApuracaoListFiltersType): boolean => filters.status.length > 0 || filters.busca.trim().length > 0 || filters.periodoInicio !== null || filters.periodoFim !== null || filters.somenteComErros;
export function ApuracaoListFilters(t0) {
  const $ = _c(46);
  const {
    filters,
    onChange,
    onClear
  } = t0;
  const activeStatus = filters.status[0] ?? "TODOS";
  let t1;
  if ($[0] !== filters) {
    t1 = isFiltering(filters);
    $[0] = filters;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const showClear = t1;
  let t2;
  if ($[2] !== onChange) {
    t2 = value => {
      if (value === "TODOS") {
        onChange({
          status: []
        });
      } else {
        onChange({
          status: [value as ApuracaoStatus]
        });
      }
    };
    $[2] = onChange;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const handleStatusChange = t2;
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <FeatherSearch className="absolute top-9 left-3 z-10 h-4 w-4 text-neutral-400" />;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== onChange) {
    t4 = event => onChange({
      busca: event.target.value
    });
    $[5] = onChange;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== filters.busca || $[8] !== t4) {
    t5 = <div className="relative flex-1">{t3}<TextField label="Buscar por cliente ou produto"><TextField.Input placeholder="Nome do tenant ou produto" value={filters.busca} onChange={t4} className="pl-9" /></TextField></div>;
    $[7] = filters.busca;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <Select.Content>{STATUS_OPTIONS.map(_temp)}</Select.Content>;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== activeStatus || $[12] !== handleStatusChange) {
    t7 = <div className="w-full md:w-48"><Select label="Status" value={activeStatus} onValueChange={handleStatusChange} placeholder="Selecione">{t6}</Select></div>;
    $[11] = activeStatus;
    $[12] = handleStatusChange;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  const t8 = filters.periodoInicio ?? "";
  let t9;
  if ($[14] !== onChange) {
    t9 = event_0 => onChange({
      periodoInicio: event_0.target.value || null
    });
    $[14] = onChange;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== t8 || $[17] !== t9) {
    t10 = <div className="w-full md:w-40"><TextField label="Inicia a partir de"><TextField.Input type="date" value={t8} onChange={t9} /></TextField></div>;
    $[16] = t8;
    $[17] = t9;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  const t11 = filters.periodoFim ?? "";
  let t12;
  if ($[19] !== onChange) {
    t12 = event_1 => onChange({
      periodoFim: event_1.target.value || null
    });
    $[19] = onChange;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] !== t11 || $[22] !== t12) {
    t13 = <div className="w-full md:w-40"><TextField label={"Termina at\xE9"}><TextField.Input type="date" value={t11} onChange={t12} /></TextField></div>;
    $[21] = t11;
    $[22] = t12;
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  let t14;
  if ($[24] !== t10 || $[25] !== t13 || $[26] !== t5 || $[27] !== t7) {
    t14 = <div className="flex w-full flex-col gap-3 md:flex-row md:items-end">{t5}{t7}{t10}{t13}</div>;
    $[24] = t10;
    $[25] = t13;
    $[26] = t5;
    $[27] = t7;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  let t15;
  if ($[29] !== onChange) {
    t15 = checked => onChange({
      somenteComErros: checked
    });
    $[29] = onChange;
    $[30] = t15;
  } else {
    t15 = $[30];
  }
  let t16;
  if ($[31] !== filters.somenteComErros || $[32] !== t15) {
    t16 = <Switch checked={filters.somenteComErros} onCheckedChange={t15} />;
    $[31] = filters.somenteComErros;
    $[32] = t15;
    $[33] = t16;
  } else {
    t16 = $[33];
  }
  let t17;
  if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <span className="text-sm text-neutral-700">Mostrar apenas ciclos com eventos rejeitados</span>;
    $[34] = t17;
  } else {
    t17 = $[34];
  }
  let t18;
  if ($[35] !== t16) {
    t18 = <label className="flex cursor-pointer items-center gap-3">{t16}{t17}</label>;
    $[35] = t16;
    $[36] = t18;
  } else {
    t18 = $[36];
  }
  let t19;
  if ($[37] !== onClear || $[38] !== showClear) {
    t19 = showClear && <Button variant="neutral-tertiary" size="small" icon={<FeatherX />} onClick={() => onClear()}>Limpar filtros</Button>;
    $[37] = onClear;
    $[38] = showClear;
    $[39] = t19;
  } else {
    t19 = $[39];
  }
  let t20;
  if ($[40] !== t18 || $[41] !== t19) {
    t20 = <div className="flex w-full items-center justify-between gap-3 border-t border-neutral-100 pt-3">{t18}{t19}</div>;
    $[40] = t18;
    $[41] = t19;
    $[42] = t20;
  } else {
    t20 = $[42];
  }
  let t21;
  if ($[43] !== t14 || $[44] !== t20) {
    t21 = <div className="bg-default-background flex w-full flex-col gap-3 rounded-[16px] border border-solid border-neutral-200 p-4">{t14}{t20}</div>;
    $[43] = t14;
    $[44] = t20;
    $[45] = t21;
  } else {
    t21 = $[45];
  }
  return t21;
}
function _temp(option) {
  return <Select.Item key={option.value} value={option.value}>{option.label}</Select.Item>;
}